import { h, Component } from 'preact'
import axios, {AxiosResponse} from 'axios'
import TeamNotesPanel from './TeamNotesPanel'
import tracker from '../../components/tracker/publish'

type Props = {
  topicContentType: string,
  topicId: string | number,
  topicTitle: string,
  topicUrl: string
}

type State = {
  contentFromServer: string,
  contentInTextarea: string,
  updatedBy: string,
  updatedAt: string,
  showButtons: boolean,
  isLoading: boolean
}

class TeamNotes extends Component<Props, State> {
  private endpoint: string = '/teamNote'
  private topicId: string | number;

  constructor (props: Props) {
    super()
    this.topicId = props.topicId
    this.state = {
      contentFromServer: '',
      contentInTextarea: '',
      updatedBy: '',
      updatedAt: '',
      showButtons: false,
      isLoading: false
    }
  }

  componentDidMount () {
    axios.get(`${this.endpoint}/${this.topicId}`)
      .then(res => this.handleResponse(res))
      .catch(e => {}) /* This is to avoid console errors when there is no note available for the topic */
  }

  trackTeamNoteSaved () {
    const { topicContentType, topicId, topicTitle, topicUrl } = this.props
    const { userid, role, name } = window.inSidedData.user
    tracker.trackEvent('userevent', {
      type: 'Team Note Saved',
      topic_content_type: topicContentType,
      topic_id: topicId,
      topic_title: topicTitle,
      topic_url: topicUrl,
      saved_by_user_id: userid,
      saved_by_user_primary_role: role,
      saved_by_user_name: name
    })
  }

  handleResponse (response: AxiosResponse) {
    const { content, updatedBy, updatedAt } = response.data
    this.setState({
      contentFromServer: content,
      contentInTextarea: content,
      updatedBy: updatedBy,
      updatedAt: updatedAt
    })
  }

  onContentChange (value: string) {
    this.setState({ contentInTextarea: value })
  }

  onTextareaFocus () {
    if (!this.state.showButtons) {
      this.setState({ showButtons: true })
    }
  }

  onSaveChanges () {
    this.setState({ isLoading: true })
    axios.post(
      `${this.endpoint}/save`, {
        topicId: this.topicId,
        content: this.state.contentInTextarea })
      .then(res => {
        this.handleResponse(res)
        this.trackTeamNoteSaved()
      })
      .finally(() => {
        this.setState({
          showButtons: false,
          isLoading: false
        })
      })
  }

  onCancel () {
    this.setState({
      contentInTextarea: this.state.contentFromServer,
      showButtons: false
    })
  }

  render (_: Props, { contentInTextarea, isLoading, updatedBy, updatedAt, showButtons } : State) {
    return (
      <TeamNotesPanel
        updatedBy={updatedBy}
        updatedAt={updatedAt}
        contentInTextarea={contentInTextarea}
        showButtons={showButtons}
        isLoading={isLoading}
        onContentChange={(value: string) => this.onContentChange(value)}
        onTextareaFocus={() => this.onTextareaFocus()}
        onSaveChanges={() => this.onSaveChanges()}
        onCancel={() => this.onCancel()}
      />
    )
  }
}

export default TeamNotes
